import React from 'react';
import NodeBlogTeaser from './Teaser';
import NodeBlogFull from './Full';

const NodeBlog = (props) => {
  const { viewMode } = props;
  switch (viewMode) {
    case 'teaser':
      return <NodeBlogTeaser {...props} />;

    default:
      return <NodeBlogFull {...props} />;
  }
};

export default NodeBlog;
